function ChevronDownIcon({ className = '' }: Readonly<{ className?: string }>) {
    return (
        <svg
            width={14}
            height={14}
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={`block size-[14px] shrink-0 ${className}`}
            aria-hidden='true'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.66112 5.04656C3.87012 4.8456 4.20247 4.85211 4.40344 5.06112L7 7.81754L9.59656 5.06112C9.79753 4.85211 10.1299 4.8456 10.3389 5.04656C10.5479 5.24753 10.5544 5.57988 10.3534 5.78888L7.37844 8.93888C7.27946 9.04182 7.14281 9.1 7 9.1C6.85719 9.1 6.72055 9.04182 6.62156 8.93888L3.64656 5.78888C3.4456 5.57988 3.45211 5.24753 3.66112 5.04656Z'
                fill='#4A4A4A'
            />
        </svg>
    );
}

export default ChevronDownIcon;
